<template>
    <section class="  section-shaped overflow-hidden my-">

        <div class="container py-0 pb-lg">
            <div class="row justify-content-between align-items-center">
                <div class="col-lg-5 mb-5 mb-lg-0">
                    <h1 class="text-dark font-weight-light">À propos de moi</h1>
                    <p class="lead text-dark mt-4">
                        En reconversion professionnel, je me suis lancé depuis maintenant 4 ans dans l'apprentissage de la retouche photo.
                        C'est une vraie vocation pour moi. Spécialisé dans la retouche beauté j'entreprend des missions pour des photographes et des agences.</p>
                   
                </div>
                <div class="col-lg-6 mb-lg-auto">
                    <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
                        <b-carousel id="carousel1"
                                    controls
                                    indicators>
                            <!-- Text slides with image -->
                            <b-carousel-slide img-src="img/portfolio/Maayan5.jpg"></b-carousel-slide>
                            <b-carousel-slide img-src="img/portfolio/Eliza3.jpg"></b-carousel-slide>
                            <b-carousel-slide img-src="img/portfolio/kareen4.jpg"></b-carousel-slide>
                        </b-carousel>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";

export default {
  components: {
    BCarousel,
    BCarouselSlide
  }
};
</script>
<style>
</style>
